import { Filter } from './Filters';
import { MultiSelect, Text } from '@mantine/core';
import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';
import classes from './Filters.module.css';

const SelectFilter = <T,>({ filter }: { filter: Filter<T> }) => {
  const { setValidatedParam, validatedParams } = useValidatedSearchParams();

  const handleFilterChange = (value: string[]) => {
    setValidatedParam(filter.key, value?.length ? value.join(',') : null);
  };

  const value = validatedParams[filter.key]
    ? validatedParams[filter.key]?.split(',')
    : [];

  return (
    <MultiSelect
      label={
        <Text size="lg" mb={8}>
          {filter.label}
        </Text>
      }
      data={filter.options}
      value={value}
      onChange={handleFilterChange}
      clearable
      searchable
      disabled={!filter?.options?.length}
      size="md"
      classNames={{
        input: classes.darkBackground,
        options: classes.darkBackground,
        option: classes.selectOptionDark,
        dropdown: classes.darkBackground,
        pill: classes.multiSelectPill,
      }}
    />
  );
};

export default SelectFilter;
